import { useState } from 'react';

type ObjectType<T> = Record<string, T>;
type SetterType<T> = (key: string, val: T) => void;
type ResetType = () => void;
type SetType<T> = (value: Record<string, T>) => void;

const useComplexObject = <T>(initialValue: Record<string, T> = {}): [ObjectType<T>, SetterType<T>, ResetType, SetType<T>] => {
  const [obj, setObj] = useState(initialValue);
  const updateObj = (key: string, value: T) => {
    const next = { ...obj };
    next[key] = value;
    setObj(next);
  };
  const reset = () => setObj(initialValue);
  const set = (value: Record<string, T> = {}) => {
    setObj(value);
  }
  return [obj, updateObj, reset, set];
};

export default useComplexObject;
